import { useContext } from "react";
import { useSelector } from "react-redux";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import { authContext } from "../../../context/Auth/AuthContext";

const LogInAuth = () => {
  const setting = useSelector((state) => state.meta?.setting);

  const { phoneNumber, setPhoneNumber, password, setPassword, handleLogIn } =
    useContext(authContext);

  return (
    <>
      <SiteTitle title="ورود به حساب کاربری" />

      <section className="section kf-contacts-form">
        <div className="container">
          <div className="kf-reservation-form">
            <div className="kf-titles align-center mb-3">
              <div className="kf-subtitle">ورود به حساب کاربری</div>
              <h3 className="kf-title">{setting?.title}</h3>
            </div>
            <form onSubmit={handleLogIn}>
              <div className="row flex-column justify-content-center align-items-center">
                <div className="col-12 col-sm-7 col-md-6">
                  <div className="kf-field">
                    <input
                      type="text"
                      inputMode="numeric"
                      name="phoneNumber"
                      placeholder="شماره موبایل"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                    />
                    <i className="la la-user" />
                  </div>
                </div>
                <div className="col-12 col-sm-7 col-md-6">
                  <div className="kf-field">
                    <input
                      type="password"
                      name="password"
                      placeholder="رمز عبور"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <i className="fas fa-lock" />
                  </div>
                </div>
              </div>
              <div className="kf-bts mt-4">
                <button className="kf-btn">
                  <span>ورود به حساب کاربری</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default LogInAuth;
